import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { PRODUCT_ENDPOINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ProductSearchQuery } from "pages/catalog/AddProduct/type";

type QueryOptionsWithoutQueryFn = Omit<UseQueryOptions<any>, "queryFn">;

const defaultKeyword = "پ چ ج ح خ ه ع غ ف ق ث ص ض گ ک م ن ت ا ل ب ی س ش . و ئ د ذ ر ز ط ظ p o i u y t r e w q l k j h g f d s a , m n b v c x z"

export const useSearchProductsList = (options?: QueryOptionsWithoutQueryFn) =>
  useQuery<any>({
    retry: 0,
    ...(options ?? {}),
    queryFn: async ({ queryKey }) => {
      const [, { keyword, productCategoryId, brandId, page, pageSize }] =
        queryKey as ProductSearchQuery[];

      let queries = "?";
      // if (keyword) queries += `keyword=${keyword}&`;
      queries += `keyword=${(keyword?.length ?? 0) > 0 ? keyword : defaultKeyword}&`;
      if (productCategoryId)
        queries += `productCategoryId=${productCategoryId}&`;
      if (brandId) queries += `brandId=${brandId}&`;
      if (page) queries += `page=${page}&`;

      queries += `pageSize=${pageSize || 20}&`;

      const result = await instance.get(
        `${PRODUCT_ENDPOINTS.search_list}${queries}`
      );

      return result.data?.data ?? {};
    },
    queryKey: options?.queryKey
      ? [PRODUCT_ENDPOINTS.search_list, ...options.queryKey]
      : [PRODUCT_ENDPOINTS.search_list],
  });
